interface IApiHostsMap {
  [key: string]: string;
}

const apiHostsMap: IApiHostsMap = {
  local: 'http://localhost:8080/',
  development: 'https://managem8dev.azurewebsites.net/',
  production: 'https://api.manage-mate.app/',
  test: 'https://managem8dev.azurewebsites.net/',
};

const nodeEnv = import.meta.env.MODE || 'development';
// const nodeEnv = 'production';

const BASE_URL = apiHostsMap[nodeEnv];

const SENTRY_DNS = 'https://d0e813a07faa854071ecdbba1f49067c@o4506575974760448.ingest.sentry.io/4506575977381888';

const CRISP_ID = 'e9270db2-a662-48cf-8e49-a0ed011c935b';
const CLARITY_ID = 'jrtasug19z';
const MGM_ADMIN = 'https://managem8admin.z13.web.core.windows.net/';

const DISCORD_LINK = 'https://discord.com/invite/RS5KrUnZ';

const MUI_KEY = '5bf61beecf35f596ee98b556590fa64fTz05NjUzNixFPTE3NTU3NjQ5OTIwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLFBWPWluaXRpYWwsS1Y9Mg==';

const AZURE_FUNCTION_CODE = 'V0-cHHH-MjETrgcfXgkDwtzoZSih64vkWzDsehQgZEC7AzFu7rktLw%3D%3D';

const PUBLIC_POSTHOG_KEY = 'phc_7uxfEFGk91OkntuF6VfZfcezOYCNbHDe2KsTyjsb0U7';
const PUBLIC_POSTHOG_HOST = 'https://us.i.posthog.com';

export {
  BASE_URL,
  SENTRY_DNS,
  CRISP_ID,
  MGM_ADMIN,
  CLARITY_ID,
  DISCORD_LINK,
  MUI_KEY,
  AZURE_FUNCTION_CODE,
  PUBLIC_POSTHOG_KEY,
  PUBLIC_POSTHOG_HOST,
};
